// DS7.4.1, but only the text.
import React from 'react';
import c from 'classnames';

interface Props {
  children: React.ReactNode;
  weight: 'bld' | 'reg';
  className?: string;
}

/**
 * Takes {@link Props.weight} and converts it to one of our global font CSS class names.
 */
function weightToClassName(weight: Props['weight']) {
  switch (weight) {
    case 'bld':
      return 'f-14-bld';
    case 'reg':
    default:
      return 'f-14-reg';
  }
}

/**
 * DS7.4.1, but only the text.
 *
 * A helper component with some typescript guidance to keep our banner text somewhat similar. Only bold and regular weight
 * variants of the same font size are supported. Use this in tandem with other {@link @wix/da-ds/pkg/Banner/lego} components when
 * building a variant of DS7.4.1
 */
const BannerMessage: React.FC<Props> = ({ children, weight, className }) => {
  return (
    <span className={c(weightToClassName(weight), className)}>{children}</span>
  );
};

BannerMessage.displayName = 'BannerMessage';

export default BannerMessage;
